export interface WorkerNote {
	id: string;
	content: string;
	collaboratorId: string | null;
	collaboratorName: string;
	createdAt: string;
	updatedAt: string;
}

export interface CreateNoteResponse {
	noteId: string;
}

export interface CreateNotePayload {
	content: string;
}

export interface UpdateNotePayload {
	content: string;
}

export interface InterviewReport {
	id: string;
	workerId: string;
	summary: string;
	collaboratorId: string | null;
	collaboratorName: string;
	agencyId: string;
	createdAt: string;
}

export interface CreateInterviewPayload {
	summary: string;
}

export interface UpdateInterviewPayload {
	summary: string;
}

export interface InterviewAiSuggestionsPayload {
	click_number: number;
	existing_questions: string[];
}

export interface InterviewAiSuggestionsResponse {
	questions: string[];
}

export interface InterviewAiSummaryPayload {
	interview_qa: string;
	cv_parsed_data: string;
	overall_opinion: string;
}

export interface InterviewAiSummaryResponse {
	summary: string;
}

export interface SearchDuplicatesRequest {
	firstname?: string;
	lastname?: string;
	email?: string;
	phone?: string;
	nir?: string;
	birthDate?: string;
	excludeWorkerId?: string;
}

export enum DuplicateScenario {
	PERFECT_MATCH = 'PERFECT_MATCH',
	SAME_NAME_EMAIL_DIFF_PHONE = 'SAME_NAME_EMAIL_DIFF_PHONE',
	SAME_NAME_PHONE_DIFF_EMAIL = 'SAME_NAME_PHONE_DIFF_EMAIL',
	SAME_NAME_EMAIL_PHONE_DIFF_FIRSTNAME = 'SAME_NAME_EMAIL_PHONE_DIFF_FIRSTNAME',
	SAME_FIRSTNAME_EMAIL_PHONE_DIFF_LASTNAME = 'SAME_FIRSTNAME_EMAIL_PHONE_DIFF_LASTNAME',
}

export enum DuplicateResolutionAction {
	AUTO_MERGE = 'AUTO_MERGE',
	MANUAL_REVIEW = 'MANUAL_REVIEW',
	PROFILE_LINK = 'PROFILE_LINK',
}

export interface DuplicateWorkerResponse {
	id: string;
	firstname: string;
	lastname: string;
	email?: string | null;
	phone?: string | null;
	birthDate?: string | null;
	birthPlace?: string | null;
	nir?: string | null;
	picture?: string | null;
	workerType?: string | null;
	workerStatus?: string | null;
	candidateStatus?: string | null;
	evoliaId?: number | null;
	agencies: Array<{ agencyId: string; agencyName?: string | null }>;
	jobs: Array<{ jobId: string; jobLabel?: string | null }>;
	nameSlugScore: number;
	matchReasons: string[];
	scenario: DuplicateScenario;
	action: DuplicateResolutionAction;
	updateProfileData: boolean;
}
